import { Button, TableCellLayout } from '@fluentui/react-components'
import { Desktop24Regular } from '@fluentui/react-icons'
import { useNavigate } from 'react-router-dom'
import { RestSchemas } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'

type MessagesSubscriptionsOrganisationWorkspace = RestSchemas['Messages.Subscriptions.OrganisationWorkspace']

export const ProjectCellContent = ({ item }: { item: MessagesSubscriptionsOrganisationWorkspace }) => {
  const orgId = useGetSearchParam<number>('orgId')
  const orgName = useGetSearchParam('orgName')
  const navigate = useNavigate()
  return (
    <TableCellLayout
      media={
        <Button
          appearance="subtle"
          size="large"
          icon={<Desktop24Regular color={!item.isFrozen ? '#D04A02' : '#D1D1D1'} />}
          onClick={() =>
            navigate(
              //TODO: add &appKey=${item.appKey} after Rory adds it to the '/rest/subscriptions/organisations/workspaces' response
              `/workspace?orgId=${orgId}&orgName=${orgName}&subscriptionId=${item.workspaceId}&tab=details&appName=${item.applicationName}&projectId=${item.projectId}&projectName=${item.projectName}`
            )
          }
        />
      }
    >
      <div
        style={{
          flexDirection: 'column',
          display: 'flex',
          paddingTop: '.5rem',
          paddingBottom: '.5rem',
          gap: '5px',
          lineHeight: '1rem',
        }}
      >
        <span style={{ fontSize: '16px' }}>{item.projectName}</span>
        <span style={{ color: '#979797', fontSize: 'small' }}>{item.applicationName}</span>
      </div>
    </TableCellLayout>
  )
}
